export const GET_NOTEBOOKS = "GET_NOTEBOOKS";
export const GET_NOTEBOOK_BY_ID = "GET_NOTEBOOK_BY_ID";
export const UPDATE_NOTEBOOK = "UPDATE_NOTEBOOK";
export const DELETE_NOTEBOOK = "DELETE_NOTEBOOK";
export const CREATE_NOTEBOOK = "CREATE_NOTEBOOK";
